import { render } from "./EditarModelo.vue?vue&type=template&id=2211b95c"
import script from "./EditarModelo.vue?vue&type=script&lang=js"
export * from "./EditarModelo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__